<template>
<div class="row no-gutters">
  <div class="col-12">
   <div class="row clearMargin" v-if="noCarrierFlag==true">
     <!--Warning Alert-->
   <div class="col alert alert-warning text-left smaller-font-content py-2 mt-4" role="alert">
    <div class="row no-gutters">
       <div class="d-inline-block my-auto mr-2 align-middle"><i class="fas fa-exclamation-circle"></i></div>
       <div class="d-inline-block col"><strong>Oops!</strong> It looks like there are no direct integration carriers configured for this agency.</div>
   </div>
  </div>
  </div>
   <div class="row" v-if="noCarrierFlag==false">
    <div class="col-12 col-md-6 px-3 my-2 p-2">
     <fieldset class="border border-primary rounded container ">
      <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Select Carrier</legend>
      <div class="alert alert-primary  py-2 w-70 .mb-4" role="note">
          <div class="row no-gutters">
            <div class="d-inline-block pr-2 my-auto">
              <img width="20px" height="20px" src="../../../assets/info-circle-blue.svg" alt="info">
            </div>
            <div class="col d-inline-block my-auto smaller-font-content" v-html="infoContent()">
            </div>
          </div>
        </div>
       <input-select :fieldData="carrierOptionsArr" />
      </fieldset>
  </div>
  <div class="col-12 col-md-6 px-3 my-2 p-2" v-show="isQRPAdmin">
      <fieldset class="border border-primary rounded container ">
      <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Add State Login</legend>
      <div class="alert alert-primary  py-2 w-70 smallerPaddingAlert .mb-4" role="note">
          <div class="row no-gutters">
            <div class="d-inline-block pr-2 my-auto">
              <img width="16px" height="16px" src="../../../assets/info-circle-blue.svg" alt="info">
            </div>
            <div class="col d-inline-block my-auto smaller-font-content" >Some states may not be appointed for this agency or will not have a direct integration for this carrier.
            </div>
          </div>
        </div>
        <b-container fluid class="clearPadding">
          <b-row class="no-gutters" >
            <b-col  xl="3"  lg="6" md="3" sm="6" class="minWidthcol" >
             <input-select :fieldData="StatesOptionsArr" />
            </b-col>
             <b-col xl="3"   lg="6" md="3" sm="6" class="p-2 mt_6 minButtonWidthcol" >
              <button type="submit" class="btn btn-primary addStateBtn " :disabled="requireState"   @click.prevent="AddState">Add State</button>
             </b-col>
          </b-row>
        </b-container>
       </fieldset>
       </div>
 </div>
 <div class="row">
      <div class="col-12">
        <hr id="carrier-hr-bottom" class="border border-primary">
      </div>
 </div>
 <b-container fluid class="bv-example-row no-gutters clearPadding">
  <b-row class="clearPadding">
    <b-col class="fixwidth"  xl="2"  lg="4" md="4" sm="6" v-for="(subItem) in addMoreState" :key="subItem">
     <carrierLoginUpdater v-if="addCrredFlag==true" :progID='progID' :state='subItem' :permissionRole="isQRPAdmin"  :sId='sId' @CredentialUpdateMsg='UpdateSucessStatus' @CredentialSaveFailMsg='UpdateFailStatus' @deleteStateflag='deletedState'/>
    </b-col>
  </b-row>
</b-container>
</div>
<b-container fluid class="bv-example-row no-gutters clearPadding">
  <b-row class="clearPadding">
    <b-col class="fixwidth"  xl="2"  lg="4" md="4" sm="6" v-for="(subItem) in currentCarriersCred" :key="subItem.stateCode" >
    <!-- <b-col md="4" v-for="index in 8"  :key="index" > -->
     <EditcarrierLoginUpdater v-if="editCrredFlag==true && subItem.addStateComp=='false'" :progID='progID'  :sId='sId'  :currentCarriersCred="currentCarriersCred" :permissionRole="isQRPAdmin" :subItem="subItem"  @CredentialUpdateMsg='UpdateSucessStatus' @CredentialSaveFailMsg='UpdateFailStatus' @deleteStateflag='deletedState'></EditcarrierLoginUpdater>
     <carrierLoginUpdater v-if="editCrredFlag==true && subItem.addStateComp=='true'" :state='subItem.stateCode' :progID='progID'  :sId='sId' :permissionRole="isQRPAdmin"  @CredentialUpdateMsg='UpdateSucessStatus' @CredentialSaveFailMsg='UpdateFailStatus' @deleteStateflag='deletedState'/>
    </b-col>
  </b-row>
</b-container>
</div>
</template>

<script>
/* eslint-disable */
import fetchData from '../../../services/fetchData';
import postData from '../../../services/postData';
import InputSelect from '../../admin/interactive/InputSelect';  
import carrierjson from '../../../../config/credMapper.json';
import common from '../../../services/common';
import carrierLoginUpdater from './carrierLoginUpdater';
import EditcarrierLoginUpdater from './EditcarrierLoginUpdater';
import store from '../../../store/store';
import stateMapper from '../../../../config/stateMapper.json';
export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
 // props: ['agencyID','sId','defaultProductCL'],
 props: ['agencyID','sId'],
  data() {
    return {
       defaultProductCL:'AU',
       tempCarrierOptionObj:{},
       currentCarriersCred: {},
       readJson:carrierjson,
       progID:'',
       addCrredFlag:false,
       editCrredFlag:false,
       isQRPAdmin:false,
       noCarrierFlag:false,
       carrierData: {},
       carrierOptionsArr:{
       field_name: 'carrier_name',
        field_value: '',
        rules: {
          required: false,
        },
        field_type: 'select',
        values: [],
        placeholder: 'Select One',
        label: 'Carrier',
        is_enabled: true,
        },
      StatesOptionsArr:{
        field_name: 'state_name',
        field_value: '',
        rules: {
          required: true,
        },
        field_type: 'select',
        values: [],
        placeholder: 'Select One',
        label: 'State',
        is_enabled: false,
        },
        readState:stateMapper,
        stateMap:{},
        filteredMap : new Map(),
        existingStateCode:[],
        selectedState:'',
        addMoreState:[],
        requireState:true,
                  
    };
  },
  // components: {
  //   InputProductFilterAppointed: () => import('../../interactive/InputProductFilterAppointed.vue')
      
  //  },

   mounted() {
    this.stateMap = new Map(Object.entries(this.readState));
    /**
     * get agency list dropdown data based on admin 
     */
    if(this.checkPermission('AddProgramPublisherCredentials')) 
      this.isQRPAdmin=true;
    // if(this.checkPermission('UpdateProgramPublisherCredentials')) 
    //   this.isQRPAdmin=true;
    this.$store.dispatch('setHandle404', true);
    this.getCarrierOption(this.defaultProductCL);
    // let url = "";
    //   //url = '/products/AU/comparativeRater/0/programs';
    //   url =`/agencies/${this.agencyID}/products/${this.defaultProductCL}/comparativeRater/0/programs`
    //   fetchData.getDashboard(url).then((response) => {
    //     if(response.data) {
    //       let tempCarrierOptionArr = response.data.programs;
    //       if(!this.isQRPAdmin)// this is for agency admin
    //       {  
    //          tempCarrierOptionArr = tempCarrierOptionArr.filter((item) => {
    //          return item.program['hasCredentials']
    //        })
    //        if(tempCarrierOptionArr.length)
    //        this.tempCarrierOptionObj=tempCarrierOptionArr;
    //        else
    //        this.noCarrierFlag=true;
    //       }
    //       else{//this is for QRP admin
    //         this.tempCarrierOptionObj=response.data.programs;
    //        }
    //         for (let aCnt = 0; aCnt < this.tempCarrierOptionObj.length; aCnt += 1) {
    //         //temporary code for only two carrier to deploy on production  
    //         // Begin-to be removed after all carrier goes in production
    //        // if(this.tempCarrierOptionObj[aCnt].program['id']===18 || this.tempCarrierOptionObj[aCnt].program['id']===226 || this.tempCarrierOptionObj[aCnt].program['id']===11 )
    //         //End-to be removed after all carrier goes in production
    //         this.carrierOptionsArr.values.push({ value: this.tempCarrierOptionObj[aCnt].program['id'], label: this.tempCarrierOptionObj[aCnt].carrier['name'] })
    //         }
    //         this.carrierOptionsArr.values.sort((a, b) => (a.label > b.label) ? 1 : -1)
    //         this.fillStateDropdown();
    //     }
    //   }).catch((error) => {
    //     let response_programs = (typeof error.response !== 'undefined' ? error.response.status : null);
    //     if(response_programs==404)
    //     {
    //     this.$store.dispatch('setHandle404', false);
    //     this.noCarrierFlag=true;
    //     }
    //     else 
    //     {
    //     console.log('error',error);
    //     }
    //   });
   
   },
   components: {
       InputSelect,
       carrierLoginUpdater,
       EditcarrierLoginUpdater
   },
   watch:{
     'defaultProductCL':function defaultProductCL(newValue) {
      this.defaultProductCL = newValue;
      this.getCarrierOption(this.defaultProductCL);
      console.log('defaultProductCL inside watch',this.defaultProductCL);
    },
     'carrierOptionsArr.field_value': function carrierSelect(pID) {
      this.$store.dispatch('setHandle404', true);
      this.StatesOptionsArr.field_value ='';
      this.addMoreState=[];
      this.existingStateCode=[];
      if(pID!=='')
      { 
      //  this.StatesOptionsArr.is_enabled=true;
       this.fetchCredforAgency(pID);
      //  this.addCrredFlag=false; //temporary for progressive carrier to show login inputs
      //  this.editCrredFlag=false;
       this.progID=pID;
       this.StatesOptionsArr.is_enabled=true;
       this.requireState=true;
      }
      else
      this.StatesOptionsArr.is_enabled=false;
      this.addCrredFlag=false;  
      this.editCrredFlag=false;
     },
     'StatesOptionsArr.field_value': function stateSelect(statecd) {
      if(statecd!==''){
      this.requireState=false;
      this.selectedState=statecd;
      if (this.existingStateCode.find(el => el === statecd)) {
         console.log("state matched");
        }
      }
      else
      this.requireState=true;
     }
   },
  methods: {
    getCarrierOption(selectedproduct){
     /**
       * get agency list dropdown data based on admin 
       */
      // if(this.checkPermission('UpdateProgramPublisherCredentials')) 
      //   this.isQRPAdmin=true;
     // this.$store.dispatch('setHandle404', true);
      let url = "";
        //url = '/products/AU/comparativeRater/0/programs';
        url =`/agencies/${this.agencyID}/products/${selectedproduct}/comparativeRater/0/programs`
        fetchData.getDashboard(url).then((response) => {
        if(response.data) {
          let tempCarrierOptionArr = response.data.programs;
          if(!this.isQRPAdmin)// this is for agency admin
          {  
             tempCarrierOptionArr = tempCarrierOptionArr.filter((item) => {
             return item.program['hasCredentials']
           })
           if(tempCarrierOptionArr.length)
           this.tempCarrierOptionObj=tempCarrierOptionArr;
           else
           this.noCarrierFlag=true;
          }
          else{//this is for QRP admin
            this.tempCarrierOptionObj=response.data.programs;
            this.noCarrierFlag=false;
           }
            for (let aCnt = 0; aCnt < this.tempCarrierOptionObj.length; aCnt += 1) {
            //temporary code for only two carrier to deploy on production  
            // Begin-to be removed after all carrier goes in production
           if(this.tempCarrierOptionObj[aCnt].program['id']===18 || this.tempCarrierOptionObj[aCnt].program['id']===226 || this.tempCarrierOptionObj[aCnt].program['id']===11 || this.tempCarrierOptionObj[aCnt].program['id']===335)
            //End-to be removed after all carrier goes in production
            this.carrierOptionsArr.values.push({ value: this.tempCarrierOptionObj[aCnt].program['id'], label: this.tempCarrierOptionObj[aCnt].carrier['name'] })
            }
            this.carrierOptionsArr.values.sort((a, b) => (a.label > b.label) ? 1 : -1)
            this.fillStateDropdown();
        }
      }).catch((error) => {
        let response_programs = (typeof error.response !== 'undefined' ? error.response.status : null);
        if(response_programs==404)
        {
       // this.$store.dispatch('setHandle404', false);
        this.noCarrierFlag=true;
        }
        else 
        {
        console.log('error',error);
        }
      });
    },
    getDefaultLoginFlag(){
       let filterProgData =  this.readJson.filter(el => el.programId == this.progID);
       if(filterProgData.length>0){
         this.flagDefaultLogin=filterProgData[0].hasDefaultLogin;
         return filterProgData[0].hasDefaultLogin;
      }
     },
    fillStateDropdown(){
     this.StatesOptionsArr.values=[];
     this.stateMap.forEach((stateName,statecd) => 
     { 
     this.StatesOptionsArr.values.push({ value: statecd, label: stateName +' ('+ statecd +')'})
     })
    this.StatesOptionsArr.values.sort((a, b) => (a.value > b.value) ? 1 : -1);
    },
    AddState(){
     this.StatesOptionsArr.values = this.StatesOptionsArr.values.filter(item=>this.filterAddState(item.value,this.selectedState));
     if(this.addCrredFlag==true)
     {
     const found = this.addMoreState.findIndex(element => element === this.selectedState);
     if (found === -1)
     {this.addMoreState.push(this.selectedState);
     this.addMoreState.sort((a, b) => (a > b) ? 1 : -1);
     this.StatesOptionsArr.is_enabled=false;
     this.requireState=true;
     }
     else
     this.requireState=true;
     }
     if(this.editCrredFlag==true)
     {
     const found1 = this.currentCarriersCred.findIndex(element => element.stateCode === this.selectedState);
     if (found1 === -1)  
     {
     this.currentCarriersCred.push({stateCode: this.selectedState, fields: [{name: "CustLoginId", value: ""}, {name: "Pswd", value: ""}],addStateComp:'true'});
     this.currentCarriersCred.sort((a, b) => (a.stateCode > b.stateCode) ? 1 : -1);
     this.StatesOptionsArr.is_enabled=false;
     this.requireState=true;
     }
     else
     this.requireState=true;
     }
    },
 
    filterAddState(stateToCompare,stateToRemove){
      return stateToCompare !== stateToRemove;
     },
    UpdateFailStatus(statusflag){
     this.$emit("CredentialSubmitFailStatus",statusflag);
     },
    UpdateSucessStatus(statusflag){
     this.$emit("CredentialSubmitStatus",statusflag);
     this.addMoreState.length=0;
     this.StatesOptionsArr.field_value ='';
     this.StatesOptionsArr.is_enabled=true;
     this.fetchCredforAgency(this.progID);
     this.requireState=false;
     },
    fetchCredforAgency(val){
      let url = "";
      this.currentCarriersCred='';
      this.existingStateCode.length=0;
      this.filteredMap.clear();
     //this.addMoreState.push('AAA');// adding state null as AAA to get first null state first in sorting  
      url = `/programs/${val}/publishers/${this.sId}/credentials`;
      fetchData.getDashboard(url).then((response) => {
        if(response.data) {
          this.currentCarriersCred=response.data.credentials;
            this.currentCarriersCred.forEach((item) => {
            item.addStateComp='false';
            this.existingStateCode.push(item.stateCode);
            if(item.stateCode==='null' || item.stateCode===null)
            item.stateCode='AAA'; // changing state null to AAA to get first null state first in sorting  
            });
            this.currentCarriersCred.sort((a, b) => (a.stateCode > b.stateCode) ? 1 : -1);
            this.stateMap.forEach((value,key)=>{
           if(!this.existingStateCode.includes(key)){
               this.filteredMap.set(key,value)
              }
             }
            );
          let originalState=this.StatesOptionsArr.values.splice(0);
          this.filteredMap.forEach((stateName,statecd) => 
          { 
          this.StatesOptionsArr.values.push({ value: statecd, label:  stateName +' ('+ statecd +')' })
          this.StatesOptionsArr.values.sort((a, b) => (a.value > b.value) ? 1 : -1);
          })
          this.addCrredFlag=false;
          this.editCrredFlag=true;
          this.requireState=true;
         }
       }).catch((error) => {
       let response_status = (typeof error.response !== 'undefined' ? error.response.status : null);
       if(response_status==404)
        {
       if(this.getDefaultLoginFlag())
        {
        this.addMoreState.push('AAA');//added to show default carrier login if no cred found
        this.StatesOptionsArr.is_enabled=false;
        this.requireState=true;
        
        }
        else
        {
        this.StatesOptionsArr.is_enabled=true;
        this.requireState=true;
        this.addCrredFlag=true;
        this.editCrredFlag=false;
        }
        this.$store.dispatch('setHandle404', true);
        this.fillStateDropdown();
        this.addCrredFlag=true;
        this.editCrredFlag=false;
       }
        else 
        {
        console.log('error',error);
        }
      });
     },
      infoContent() {
      return "Carrier login configurations are unique for each agency.";
    },
     checkPermission(permissionName) {
      return common.checkPermission(permissionName);
    },
    deletedState(deletedStateCode,stateName,newStateAdded){
     let foundDeleteState;
     if(this.editCrredFlag)
       foundDeleteState = this.currentCarriersCred.findIndex(element => element.stateCode === deletedStateCode);
     else
      foundDeleteState = this.addMoreState.findIndex(element => element === deletedStateCode);
     if(newStateAdded){
      if(foundDeleteState>-1)
      {
       if(this.editCrredFlag)
       {this.currentCarriersCred.splice(foundDeleteState, 1);
       this.StatesOptionsArr.field_value ='';
       }
       else
       this.addMoreState.splice(foundDeleteState, 1)
       this.StatesOptionsArr.values.push({ value: deletedStateCode, label: stateName })
       this.StatesOptionsArr.values.sort((a, b) => (a.value > b.value) ? 1 : -1);
       this.StatesOptionsArr.field_value ='';
       this.StatesOptionsArr.is_enabled=true;
       this.requireState=false;
       this.$emit("CredentialSubmitStatus",true);
     }
     }else {
     if(this.editCrredFlag)
     this.currentCarriersCred.splice(foundDeleteState, 1)
     this.fetchCredforAgency(this.progID);
     this.StatesOptionsArr.field_value ='';
     this.StatesOptionsArr.is_enabled=true;
     this.requireState=true;
     }
    },
   },
};
</script>

<style scoped>
.noPaddingclass{
  padding-right:0px !important;
  padding-left:0px !important;
}
.fixwidth{
  min-width:260px;
}
.clearPadding{
  padding-right:0px !important;
  padding-left:0px !important;
}
.clearMargin{
    margin-right: 0;
    margin-left: 0;
}
.btn{
  text-transform: unset !important;
}
.credentials {
  display: flex;
  align-items: center;
 
}
.errorsection {
  height: 25px;
}
 .credentials LABEL {
    display: inline-flex;
    font-size: 12px;
    font-weight: 600;
  }
.password-field {
  align-items: center;
}
.text-error-msg {
  font-size: 12px;
  color: #BB0000;
  font-weight: 400;
}
.revealer {
  position: relative !important;
  left: -30px !important;
 
}
.ac-carrier-container {
  display:flex;
  align-items:center;
}
label.field-required::after {
  padding-left: 0px !important;
}
.flex-container {
  display: flex;
  background-color: DodgerBlue;
}
.flex-container > div {
  background-color: #f1f1f1;
 }
 .btn-primary.addStateBtn.disabled, .btn-primary.addStateBtn:disabled {
    color: #fff;
    background-color: #949494;
    border-color: #949494;
}
  .mt_6 {
    margin-top: 0.6rem;
}
.smallerPaddingAlert{
    padding-left: 12px; 
    padding-right: 12px;
    padding-top: 8px;
    padding-bottom: 8px;
}

@media (min-width: 1200px) {
  .minButtonWidthcol{
    min-width: 50%;
  }
  .fieldset-width {
    width: 18%;
  }
  .minWidthcol{
   min-width: 34%;
  }
  
}

@media (min-width: 992px) and (max-width: 1199px) {
  .fieldset-width {
    width: 30%;
  }
  .minWidthcol{
     min-width: 50%;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .fieldset-width {
    width: 29.5%;
  }
  .minButtonWidthcol{
   min-width: 54%;
  }
  .minWidthcol{
     min-width: 50%;
  }
 }

@media (min-width: 576px) and (max-width: 767px) {
  .fieldset-width {
    width: 44%;
  }
  .minWidthcol{
   min-width: 50%;
  }
  .spacingAddState{
    margin-right: 16%;
  }
}

@media (max-width: 575px) {
  .fieldset-width {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/agencies/CarrierCredentialUpdater.vue?04fb0c5e